import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://brocante-esprit-libre.onrender.com'
});

export default instance;
